module.exports = __webpack_public_path__ + "img/sidebar-battery-6.ea726556.svg";